import { Html } from '@mv/ui-kit/primitives';

export function AudioMedia({ alt, uri }: { alt?: string | null; uri: string }) {
	return <Html.Audio aria-label={alt ?? undefined} className="w-full" controls src={uri} />;
}
